// extracted by mini-css-extract-plugin
export var container = "_4a-0";
export var icon = "_4a-1";
export var text = "_4a-2";